export default __webpack_public_path__ + "static/media/128.3c9ac512.png";